export default __webpack_public_path__ + "static/media/2018.76ec9280.pdf";